    <div class="rewards-container">
      <div *ngIf="isConfigLoading" class="config-loading">
        <div class="loading-spinner"></div>
        <p class="loading-text">Loading rewards...</p>
      </div>

      <app-rewards-v2 *ngIf="!isConfigLoading && rewardsV2Enabled"></app-rewards-v2>
      <app-rewards-v1 *ngIf="!isConfigLoading && !rewardsV2Enabled"></app-rewards-v1>
    </div>
